<template>
  <EditorPageWrapper
    wrapperId="privacy-policy"
    :iconComponent="PrivacyIcon"
    title="PRIVACY POLICY"
    page="privacy-policy"
    collection="privacy_policy"
  />
</template>

<script>
  import EditorPageWrapper from '@/components/utilities/EditorPageWrapper.vue'
  import PrivacyIcon from '@/assets/icons/PrivacyIcon.vue'

  export default {
    name: 'PrivacyAdmin',
    components: {
      EditorPageWrapper,
    },
    setup() {
      return {
        PrivacyIcon,
      }
    },
  }
</script>

